// src/components/VisitorCount.js
// src/components/VisitorCount.js - FIXED VERSION
import React, { useState, useEffect } from "react";
import "./VisitorCount.css";

const VisitorCount = () => {
  const [visitorData, setVisitorData] = useState({ 
    dailyCount: 0, 
    yearlyCount: 0, 
    totalCount: 0 
  });
  const [hasIncremented, setHasIncremented] = useState(false);
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_URL;

  // Generate a session key based on browser session and day
  const getSessionKey = () => {
    const today = new Date().toDateString();
    return `visitor_incremented_${today}`;
  };

  useEffect(() => {
    const incrementVisitor = async () => {
      const sessionKey = getSessionKey();
      const alreadyIncremented = sessionStorage.getItem(sessionKey);
      
      if (!alreadyIncremented && !hasIncremented) {
        try {
          console.log("Incrementing visitor count...");
          const response = await fetch(`${apiUrl}/api/visitor/increment`, {
            method: "POST",
            headers: {
              'Content-Type': 'application/json'
            }
          });
          
          if (response.ok) {
            const data = await response.json();
            setVisitorData(data);
            setHasIncremented(true);
            // Mark as incremented for this day
            sessionStorage.setItem(sessionKey, 'true');
            console.log("Visitor count incremented:", data);
          } else {
            console.error("Failed to increment visitor count:", response.status);
            // Fall back to fetching current data
            fetchCurrentData();
          }
        } catch (error) {
          console.error("Error incrementing visitor count:", error);
          // Fall back to fetching current data
          fetchCurrentData();
        }
      } else {
        console.log("Already incremented today, fetching current data...");
        fetchCurrentData();
      }
    };

    const fetchCurrentData = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/visitor`);
        if (response.ok) {
          const data = await response.json();
          setVisitorData(data);
          console.log("Current visitor data fetched:", data);
        } else {
          console.error("Failed to fetch visitor data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      } finally {
        setLoading(false);
      }
    };

    if (apiUrl) {
      incrementVisitor();
    } else {
      console.error("API URL not configured");
      setLoading(false);
    }

    // Set up periodic refresh of data (without incrementing)
    const interval = setInterval(() => {
      if (apiUrl) {
        fetch(`${apiUrl}/api/visitor`)
          .then((res) => {
            if (res.ok) {
              return res.json();
            }
            throw new Error(`HTTP ${res.status}`);
          })
          .then((data) => {
            setVisitorData(data);
          })
          .catch((error) => {
            console.error("Error in periodic fetch:", error);
          });
      }
    }, 60000); // Refresh every minute

    return () => clearInterval(interval);
  }, [apiUrl, hasIncremented]);

  if (loading) {
    return (
      <div className="visitor-count-container">
        <p>Loading visitor data...</p>
      </div>
    );
  }

  return (
    <div className="visitor-count-container">
      <p><strong>Visitors Today:</strong> {visitorData.dailyCount}</p>
      <p><strong>Visitors This Year:</strong> {visitorData.yearlyCount}</p>
      <p><strong>Total Visitors:</strong> {visitorData.totalCount}</p>
    </div>
  );
};

export default VisitorCount;